import { Box, Button, Tag, Text } from '@factorialco/deprecated-design-system'
import CardsImage from 'assets/images/it-management-cards-banner.png'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  fullSize?: boolean
  showCompleteAccount?: boolean
}

const CardsBanner = ({ fullSize, showCompleteAccount }: Props) => {
  const redElipse = (
    <Box
      background="radicalRed600"
      style={{
        width: '18%',
        height: '50%',
        position: 'absolute',
        borderRadius: '50%',
        top: '20px',
        left: '-70px',
        filter: 'blur(23px)',
        opacity: '0.6',
      }}
    />
  )
  const pinkElipse = (
    <Box
      background="radicalRed1200"
      style={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        borderRadius: '50%',
        top: '60px',
        filter: 'blur(120px)',
        opacity: '0.5',
      }}
    />
  )
  const tangerineElipse = (
    <Box
      background="tangerine1000"
      style={{
        width: '25%',
        height: '50%',
        position: 'absolute',
        borderRadius: '50%',
        top: '0px',
        left: '-50px',
        filter: 'blur(32px)',
        opacity: '0.5',
      }}
    />
  )
  const purpleElipse = (
    <Box
      background="purple1000"
      style={{
        width: '40%',
        height: '100%',
        position: 'absolute',
        borderRadius: '50%',
        bottom: '20px',
        right: '-120px',
        filter: 'blur(26px)',
        opacity: '0.4',
      }}
    />
  )
  const { navigation } = useNavigation()

  return (
    <Box
      width="full"
      height="full"
      flexDirection="row"
      alignItems="center"
      borderRadius={{
        all: 'abs008',
      }}
      style={{
        position: 'relative',
        overflow: 'hidden',
      }}
      background="grey000White"
    >
      {pinkElipse}
      {tangerineElipse}
      {redElipse}
      {purpleElipse}
      <Box
        gap="s12"
        width="full"
        padding="s24"
        alignItems="center"
        style={{ position: 'relative' }}
        flexDirection={fullSize ? 'column' : 'row'}
        textAlign={fullSize ? 'center' : 'left'}
      >
        <Box width="full" gap="s12" alignItems={fullSize ? 'center' : 'flexStart'}>
          <Text weight="medium" color="grey1000" size="300">
            {i18n.t('it_management.software_setups.dashboard.cards_banner.message')}
          </Text>

          {showCompleteAccount && (
            <Box width="fit-content">
              <Tag leftItem="circle" showCircle type="champagne">
                {i18n.t('expenses_v2.cards.blocks.hero_section.tag_status.incomplete')}
              </Tag>
            </Box>
          )}
        </Box>

        <Box minWidth="fit-content">
          <Button.Router
            type="secondary"
            to={navigation.software.applications.account_setup.fullPath()}
          >
            {showCompleteAccount
              ? i18n.t('expenses_v2.cards.blocks.require_onboarding.complete_account')
              : i18n.t('it_management.software_setups.dashboard.cards_banner.cta')}
          </Button.Router>
        </Box>
      </Box>

      {fullSize && (
        <Box width="full" padding="s12" style={{ position: 'relative' }}>
          <img width="100%" src={CardsImage} />
        </Box>
      )}
    </Box>
  )
}

export default CardsBanner
